import { createReducer } from '@reduxjs/toolkit';
import initialState from './initialState';

import { reducer as addFiles } from './addFiles';
import { reducer as addToSelection } from '../import/addToSelection';
import { reducer as removeFromSelection } from '../import/removeFromSelection';
import { reducer as remove } from '../import/remove';
import { reducer as changeField } from '../import/changeField';
import { reducer as addToListField } from '../import/addToListField';
import { reducer as removeFromListField } from '../import/removeFromListField';
import { reducer as startUpload } from './startUpload';
import { reducer as updateFile } from '../import/updateFile';
import { reducer as preUploadValidation } from '../import/preUploadValidation';

const importReducer = createReducer(
  initialState,
  (builder) => {
    addFiles(builder);
    addToSelection(builder);
    removeFromSelection(builder);
    remove(builder);
    changeField(builder);
    addToListField(builder);
    removeFromListField(builder);
    startUpload(builder);
    updateFile(builder);
    preUploadValidation(builder);
  },
);

export default importReducer;
